import * as PropTypes from 'prop-types';

/** A checker that matches the React.Ref type. */
export var refPropType = PropTypes.oneOfType([PropTypes.func, PropTypes.object]);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@stardust-ui/react-component-ref/dist/es/types.js
// module id = 85
// module chunks = 2